<div
  class="qty_label"
  [style]="{background, 'width': size, color, 'height': size}">
  {{ number }}
</div>
